import React, { FC, memo } from 'react';

import HelpCenterLink from 'application/components/HelpCenterLink';
import { ModalTypes, useModalContext } from 'application/providers/ModalProvider';
import SimplyToolbar from 'application/components/SimplyToolbar';
import { HELP_CENTER_REPORTS_LINK } from 'application/pages/constants';

import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import { AdcampaignPlaybackReportTypeForInput } from '@shared/api/graphql/generated';
import { TEXTS } from './texts';
import ReportRequestMenu from './ReportRequestMenu';

interface ReportToolbarProps {
  rightholderId: string;
  rightholderTitle: string;
  showButton: boolean;
  helpLink?: string;
  onHelpCenterClick: () => void;
  refetchReports: () => void;
  adcampaignReportType: AdcampaignPlaybackReportTypeForInput;
}

export const ReportToolbar: FC<ReportToolbarProps> = memo(
  ({ showButton, helpLink = HELP_CENTER_REPORTS_LINK, onHelpCenterClick, refetchReports, adcampaignReportType }) => {
    const { isMobile } = useMedia();
    const { openModal } = useModalContext();
    const isAudioAdsReport = adcampaignReportType === AdcampaignPlaybackReportTypeForInput.AudioAds;

    const onOpenReportClick = () => {
      openModal(ModalTypes.REPORT_CREATE_AD_CAMPAIGNS, {
        refetchReports,
        adcampaignReportType,
      });
    };

    const onOpenByDaysReportClick = () => {
      openModal(ModalTypes.REPORT_CREATE_AD_CAMPAIGNS_BY_DAYS, {
        refetchReports,
      });
    };

    return (
      <SimplyToolbar
        dataTestId="reports_toolbar"
        ButtonPrefix={
          !isMobile && (
            <HelpCenterLink
              link={helpLink}
              onClick={onHelpCenterClick}
              elementId="reports_help_center"
            />
          )
        }
        createButtonTitle={isAudioAdsReport ? TEXTS.REQUEST_REPORT_BUTTON_TEXT : TEXTS.REQUEST_EARLY_REPORT_BUTTON_TEXT}
        onButtonClick={onOpenReportClick}
        renderCreateButton={
          isAudioAdsReport
            ? () => (
                <ReportRequestMenu
                  onOpenEarlyReport={onOpenReportClick}
                  onOpenByDaysReport={onOpenByDaysReportClick}
                />
              )
            : undefined
        }
        showButton={showButton}
      />
    );
  }
);
